import styled, { css } from 'styled-components';
import { EEkycStatuses } from '../../../../types/entities/users';
import Table from '@material-ui/core/Table';
import { Tabs } from '@material-ui/core';

export const CellButtonsStyled = styled.div`
    display: inline-grid;
    grid-auto-flow: column;
    grid-auto-columns: max-content;
    gap: 1rem;
    justify-content: flex-start;
    width: 100px;
`;

export const CellButtonContentStyled = styled.span`
    display: grid;
    justify-content: center;
    align-items: center;
    grid-auto-flow: column;
    gap: 0.5rem;
    svg {
        width: 1rem;
    }
`;

export const TableStyled = styled(Table)``;

export const CellEkycStatusProcessing = styled.span`
    display: grid;
    grid-auto-flow: row;
    gap: 0.5rem;
    justify-content: flex-start;
`;

export const CellEkycStatus = styled.span<{ status: EEkycStatuses }>`
    ${({ status, theme }) => {
        switch (status) {
            case EEkycStatuses.VERIFIED:
                return css`
                    color: ${theme.branding.primary.main};
                `;
            case EEkycStatuses.UNVERIFIED:
                return css`
                    color: ${theme.branding.quaternary.main};
                `;
            case EEkycStatuses.PROCESSING:
                return css`
                    color: ${theme.branding.secondary.main};
                `;
            case EEkycStatuses.REJECTED:
                return css`
                    color: ${theme.branding.tertiary.main};
                `;
        }
    }}
`;

export const Root = styled.div`
    display: grid;
    grid-auto-flow: row;
    gap: 8px;

    .rowrow {
        grid-auto-columns: max-content 1fr 1fr;
        gap: 1rem;
    }

    .export-col {
        place-self: end;
    }
`;

export const TabsStyled = styled(Tabs)`
    &.MuiTabs-root {
        border-bottom: 1px solid #cfcfcf;
        min-height: 43px;
        height: 43px;
        margin-bottom: 10px;
    }

    .MuiTab-root {
        font-size: 14px;
        font-weight: 600;
        min-width: auto;
        text-transform: capitalize;
    }
`;
